import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'

export default class ContentWrapper extends PureComponent {
  static propTypes = {
    layout: PropTypes.object,
  }

  static defaultLayout = {
    xs: { span: 22, offset: 1 },
    sm: { span: 20, offset: 2 },
    md: { span: 20, offset: 2 },
    lg: { span: 20, offset: 2 },
    xl: { span: 20, offset: 2 },
    xxl: { span: 20, offset: 2 },
  }

  render() {
    const { layout, children, ...props } = this.props

    const colLayout = { ...ContentWrapper.defaultLayout, ...layout }
    return (
      <Row {...props}>
        <Col {...colLayout}>{children}</Col>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ContentWrapper.jsx